ACC.orderReports = {
  statusListValue: '',
  statusListCount: 0,
  dateRangeValue: '',
  loaderDefault: '.ph-loader__default',
  orderstatuslistClass: '.ph-report-orderstatuslist',
  daterangelistClass: '.ph-report-daterangelist',
  reportsErrorClass: '.ph-orderreports__error',
  isProcessingReport: false,
  init: function() {
    $(document).on('click', '#reportOrderstatus', function() {
      $(ACC.orderReports.orderstatuslistClass).toggle();
      ACC.orderReports.checkStatus();
      $(ACC.orderReports.reportsErrorClass).addClass('hiddenClass');
      $(this).removeClass('ph-dateredborder');
    });
    $(document).on('click', '.ph-reportsts__apply', function() {
      $(ACC.orderReports.orderstatuslistClass).hide();
      ACC.orderReports.applyStatus(true);
    });
    $(document).on('click', '.ph-reportsts__clear', function() {
      $('.ph-oslistitm > input:checkbox').removeAttr('checked');
      $('.ph-selectallcheckbox > input:checkbox').removeAttr('checked');
      ACC.orderReports.statusListValue = '';
      ACC.orderReports.statusListCount = 0;
    });
    $(document).on('click', '.ph-reportsts__close', function() {
      $(ACC.orderReports.orderstatuslistClass).hide();
      ACC.orderReports.checkStatus();
    });
    $(document).on('click', '#reportDateRange', function() {
      $(ACC.orderReports.daterangelistClass).toggle();
      ACC.orderReports.checkDateRange();
      $(ACC.orderReports.reportsErrorClass).addClass('hiddenClass');
      $(this).removeClass('ph-dateredborder');
    });
    $(document).on('click', '.ph-reportrange__apply', function() {
      ACC.orderReports.applydateRange(true);
    });
    $(document).on('click', '.ph-reportrange__clear', function() {
      $('.ph-rangelistitm .ph-radio').prop('checked', false);
      ACC.orderReports.dateRangeValue = '';
      $('.ph-rangecustom_start,.ph-rangecustom_end').val('');
      ACC.orderReports.clearDatePickerRange();
      ACC.orderReports.customRangeDisplay();
    });
    $(document).on('click', '.ph-reportrange__close', function() {
      $(ACC.orderReports.daterangelistClass).hide();
      ACC.orderReports.checkDateRange();
    });
    $(document).on('click', '#reportGenerateButton', function() {
      ACC.orderReports.reportGenerateAction();
    });
    $(document).on('click', '.ph-radio', function() {
      ACC.orderReports.customRangeDisplay();
    });
    $(document).on('blur', '.ph-rangecustom_start,.ph-rangecustom_end', function() {
      $(this).removeClass('ph-dateredborder');
    });

    var clicktargets = ',body>.ui-datepicker,.ui-datepicker-prev,.ui-datepicker-next,.ui-icon';

    $('body').click(function(e) {
      if ($(e.target).closest('.ph-report-orderstatuslist,.ph-report_orstatuswrap' + clicktargets).length === 0) {
        $('.ph-report-orderstatuslist').hide();
        ACC.orderReports.statusDropdownToggle();
      }

      if ($(e.target).closest('.ph-report-daterangelist,.ph-report_daterangewrap' + clicktargets).length === 0) {
        $('.ph-report-daterangelist').hide();
        ACC.orderReports.checkDateRange();
      }
    });
    $(document).on('click', '.ph-orderreports_popupclose', function() {
      $.colorbox.close();
    });
  },
  checkAllItemsStatus: function() {
    var uncheckedCount = $(document).find('.ph-oslistitm > input').not(':checked').length;

    if (uncheckedCount === 0) {
      $('.ph-selectallcheckbox > input').prop('checked', true);
    } else {
      $('.ph-selectallcheckbox > input').prop('checked', false);
    }
  },
  checkAllItems: function() {
    $(document).on('click', '.ph-selectallcheckbox > input', function() {
      var isChecked = $(this).is(':checked');

      $(document).find('.ph-oslistitm > input').each(function() {
        if (isChecked) {
          $(this).prop('checked', true);
        } else {
          $(this).prop('checked', false);
        }
      });
    });
    $(document).on('click', '.ph-oslistitm > input', function() {
      ACC.orderReports.checkAllItemsStatus();
    });
  },
  customRangeDisplay: function() {
    if ($('.ph-rangelistitm .ph-customradio:checked').val() === 'custom') {
      $('.ph-rangecustom').show();
    } else {
      $('.ph-rangecustom').hide();
    }
  },
  applyStatus: function() {
    var statusListValue = '';

    $(document).find('.ph-oslistitm > input:checked').each(function() {
      if (statusListValue) {
        statusListValue = statusListValue + ',' + $(this).val();
      } else {
        statusListValue = $(this).val();
      }
    });

    ACC.orderReports.statusListValue = statusListValue;
    ACC.orderReports.statusListCount = $(document).find('.ph-oslistitm > input:checked').length;
    ACC.orderReports.checkStatus();
  },
  checkStatus: function() {
    $('.ph-oslistitm > input:checkbox').removeAttr('checked');

    var statusListArray = ACC.orderReports.statusListValue.split(',');

    $(document).find('.ph-oslistitm > input').each(function() {
      if (statusListArray.indexOf($(this).val()) >= 0) {
        $(this).prop('checked', true).attr('checked', true);
      }
    });
    ACC.orderReports.statusDropdownToggle();
    ACC.orderReports.checkAllItemsStatus();
  },
  statusDropdownToggle: function() {
    if (ACC.orderReports.statusListCount > 0 && $('.ph-report-orderstatuslist:visible').length === 0) {
      $('.ph-statusListCount').text(ACC.orderReports.statusListCount + ' ' + $('.ph-selectedMsg').html()).show();
      $('.ph-statusListlabel').hide();
    } else {
      $('.ph-statusListCount').hide();
      $('.ph-statusListlabel').show();
    }
  },
  applydateRange: function() {
    ACC.orderReports.dateRangeValue = $(document).find('.ph-rangelistitm > input:radio:checked').val();

    var isError = false;

    if ($('.ph-rangecustom_start').val() === '' && ACC.orderReports.dateRangeValue === 'custom') {
      $('.ph-rangecustom_start').addClass('ph-dateredborder');
      isError = true;
    }

    if ($('.ph-rangecustom_end').val() === '' && ACC.orderReports.dateRangeValue === 'custom') {
      $('.ph-rangecustom_end').addClass('ph-dateredborder');
      isError = true;
    }

    if (isError === false) {
      $(ACC.orderReports.daterangelistClass).hide();
      ACC.orderReports.checkDateRange();
    }
  },
  checkDateRange: function() {
    $('.ph-rangelistitm .ph-radio').prop('checked', false);
    $(document).find('.ph-rangelistitm > input:radio').each(function() {
      if (ACC.orderReports.dateRangeValue === $(this).val()) {
        $(this).prop('checked', true);
      }
    });

    ACC.orderReports.dateDropdownToggle();

    ACC.orderReports.customRangeDisplay();
  },
  dateDropdownToggle: function() {
    if (ACC.orderReports.dateRangeValue && $('.ph-report-daterangelist:visible').length === 0) {
      $('.ph-daterangeValue').text($(document).find('.ph-rangelistitm > input:radio:checked').attr('label')).show();
      $('.ph-daterangeLabel').hide();
    } else {
      $('.ph-daterangeValue').hide();
      $('.ph-daterangeLabel').show();
    }
  },
  processStatusList: function(statusList) {
    var itemHtml = '',
        statusListInput = statusList,
        selectAllText = $('.selectAllStatusLabel').html();

    if (statusListInput === '') {
      statusListInput = '{"CANCELLED":"Cancelled","PROCESSING":"Processing","INVOICED":"Invoiced","SHIPPED":"Shipped"}';
    }

    if (typeof statusListInput === 'string') {
      statusListInput = JSON.parse(statusListInput);
    }

    var statusListInputSorted = Object.keys(statusListInput).sort();

    itemHtml = itemHtml + '<span class="ph-selectallcheckbox">' +
      '<input value="all" class="ph-checkbox" id="osselectall" type="checkbox">' +
      '<label for="osselectall">' + selectAllText + '</label></span>';

    statusListInputSorted.forEach(function(statusitemKey) {
      itemHtml = itemHtml + '<span class="ph-oslistitm">' +
      '<input value="' + statusitemKey + '" class="ph-checkbox" id="os' + statusitemKey + '" type="checkbox">' +
      '<label for="os' + statusitemKey + '">' + statusListInput[statusitemKey] + '</label></span>';
    });
    $('.ph-oslistwrap').html(itemHtml);
    ACC.orderReports.checkAllItems();
  },
  getStatusList: function() {
    $.ajax({
      url: ACC.config.contextPath + '/orderReport/getOrderReportStatus',
      type: 'GET',
      data: {},
      success: function(statusListResponse) {
        if (statusListResponse) {
          ACC.orderReports.processStatusList(statusListResponse);
        }
      },
      error: function() {
        ACC.orderReports.processStatusList('');
      },
      fail: function() {
        ACC.orderReports.processStatusList('');
      }
    });
  },
  dateToDateFormat: function(date) {
    var day = ('0' + date.getDate()).slice(-2),
        month = ('0' + (date.getMonth() + 1)).slice(-2),
        year = date.getFullYear();

    return String(year) + '-' + month + '-' + day;
  },
  startDateFormat: function(todayDate) {
    if (ACC.orderReports.dateRangeValue === '30') {
      todayDate.setDate(todayDate.getDate() - 30);
    } else if (ACC.orderReports.dateRangeValue === '60') {
      todayDate.setDate(todayDate.getDate() - 60);
    } else if (ACC.orderReports.dateRangeValue === '90') {
      todayDate.setDate(todayDate.getDate() - 90);
    } else if (ACC.orderReports.dateRangeValue === '180') {
      todayDate.setDate(todayDate.getDate() - 180);
    } else if (ACC.orderReports.dateRangeValue === '365') {
      todayDate.setFullYear(todayDate.getFullYear() - 1);
    }

    return ACC.orderReports.dateToDateFormat(todayDate);
  },
  reportGenerateAction: function() {
    $(ACC.orderReports.orderstatuslistClass).hide();
    $(ACC.orderReports.daterangelistClass).hide();

    if (ACC.orderReports.dateRangeValue && ACC.orderReports.statusListCount > 0) {
      $(ACC.orderReports.reportsErrorClass).addClass('hiddenClass');
      $(ACC.orderReports.loaderDefault).show();

      var todayDate = new Date(),
          endDateValue = ACC.orderReports.dateToDateFormat(todayDate),
          startDateValue = ACC.orderReports.startDateFormat(todayDate);

      if (ACC.orderReports.dateRangeValue === 'custom') {
        endDateValue = ACC.orderReports.dateToDateFormat($('#rangecustomEnd').datepicker('getDate'));
        startDateValue = ACC.orderReports.dateToDateFormat($('#rangecustomStart').datepicker('getDate'));
      }

      $.ajax({
        url: ACC.config.contextPath + '/orderReport/generateOrderReport',
        type: 'GET',
        data: {
          orderStatus: ACC.orderReports.statusListValue,
          startDate: startDateValue,
          endDate: endDateValue
        },
        success: function(generateOrderResponse) {
          $(ACC.orderReports.loaderDefault).hide();

          if (generateOrderResponse) {
            $('.ph-reportsts__clear').trigger('click');
            $('.ph-reportrange__clear').trigger('click');
            ACC.orderReports.statusDropdownToggle();
            ACC.orderReports.dateDropdownToggle();
            ACC.orderReports.reportListProcess(true);
          }
        },
        error: function() {
          $(ACC.orderReports.loaderDefault).hide();
        },
        fail: function() {
          $(ACC.orderReports.loaderDefault).hide();
        }
      });
    } else {
      $(ACC.orderReports.reportsErrorClass).removeClass('hiddenClass');

      if (ACC.orderReports.statusListCount === 0) {
        $('#reportOrderstatus').addClass('ph-dateredborder');
      }

      if (!ACC.orderReports.dateRangeValue) {
        $('#reportDateRange').addClass('ph-dateredborder');
      }
    }
  },
  reportListProcess: function(showLoader) {
    if (showLoader) {
      $(ACC.orderReports.loaderDefault).show();
      $.colorbox({
        html: $('.ph-orderreports_popup').html(),
        width: '100%',
        maxHeight: '400px',
        maxWidth: '522px',
        close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
        overlayClose: false,
        onComplete: function() {
          ACC.common.refreshScreenReaderBuffer();
        },
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    }

    $.ajax({
      url: ACC.config.contextPath + '/orderReport/getOrderReportList',
      type: 'GET',
      data: {},
      success: function(reportListData) {
        $(ACC.orderReports.loaderDefault).hide();
        ACC.orderReports.reportListGeneration(reportListData);
      },
      error: function() {
        $(ACC.orderReports.loaderDefault).hide();
      },
      fail: function() {
        $(ACC.orderReports.loaderDefault).hide();
      }
    });
  },
  reportListGeneration: function(reportListData) {
    var htmlTemplate = '';

    $('.ph-orders_reports_loadingicon2').hide();

    if (reportListData.length > 0) {
      ACC.orderReports.isProcessingReport = false;
      reportListData.forEach(function(reportListItem) {
        var downloadIcon = '<div class="ph-orders_reports_downloadicon"></div>',
            downloadButton = '',
            phcirclecolor = '',
            createdDate = '',
            message = '';

        if (reportListItem.isStatus === true && reportListItem.mediaURL) {
          downloadButton = '<a class="ph-reportdownload_link" href="' + reportListItem.mediaURL + '">' + downloadIcon + '</a>';
        } else if (reportListItem.isStatus === false) {
          downloadButton = '<div class="ph-position-relative ph-orders_reports_loadingicon"><div class="ph-loadingspinner"></div></div>';
          phcirclecolor = 'ph-circlecolor';
          ACC.orderReports.isProcessingReport = true;
        } else {
          phcirclecolor = 'ph-circleredcolor';
          downloadButton = '<div class="ph-errorreport_div">&nbsp;</div>';
        }

        if (reportListItem.message) {
          message = reportListItem.message;
        }

        if (reportListItem.orderReportCreatedDate) {
          createdDate = reportListItem.orderReportCreatedDate;
        }

        htmlTemplate = htmlTemplate + '<div class="ph-orders_reports_item ph-p-1 ph-col-12 ph-mb-1 ph-d-flex ph-flex-row">' +
            '<div class="ph-orders_reports_widthclass">' +
              '<div class="ph-orders_report_title ph-orders_report_cols">' + message + '</div>' +
              '<div class="ph-orders_reports_createddate ph-orders_report_cols">' + createdDate + '</div>' +
              '<div class="ph-orders_reports_status ph-orders_report_cols"><span class="ph-float-left ph-ordreport_createdicon ' + phcirclecolor + '"></span><span class="ph-float-left ph-ordreport_createdmsg">&nbsp;' + reportListItem.status + '</span></div>' +
            '</div>' + downloadButton +
            '</div>';
      });
      $('.ph-ordersReports_itemcontainer').html(htmlTemplate);

      if (ACC.orderReports.isProcessingReport === true) {
        setTimeout(function() {
          ACC.orderReports.reportListProcess(false);
        }, 10000);
      }
    } else {
      $('.ph-orders_report_noreports').show();
    }
  },
  clearDatePickerRange: function() {
    $('#rangecustomStart').datepicker('option', 'minDate', null);
    $('#rangecustomStart').datepicker('option', 'maxDate', new Date());
    $('#rangecustomEnd').datepicker('option', 'minDate', null);
    $('#rangecustomEnd').datepicker('option', 'maxDate', new Date());
  },
  initCustomDatePicker: function() {
    var date = new Date(),
        dateformat = $('.ph-dateFormat').text($('.ph-dateFormat').text().replace('yyyy', 'yy')),
        rangecustomStartId = '#rangecustomStart',
        rangecustomEndId = '#rangecustomEnd';

    $(rangecustomStartId).datepicker({
      maxDate: date,
      dateFormat: dateformat.text().toLowerCase(),
      onSelect: function() {
        var rangecustomStart = $(rangecustomStartId).datepicker('getDate');
        var setMaxDtforEnd = rangecustomStart.addDays(365);

        if (setMaxDtforEnd > date) {
          setMaxDtforEnd = date;
        }

        $(rangecustomEndId).datepicker('option', 'minDate', rangecustomStart);
        $(rangecustomEndId).datepicker('option', 'maxDate', setMaxDtforEnd);
        $(this).blur();
      },
      endDate: 'today'
    });
    $(rangecustomEndId).datepicker({
      maxDate: date,
      dateFormat: dateformat.text().toLowerCase(),
      onSelect: function() {
        var rangecustomEnd = $(rangecustomEndId).datepicker('getDate'),
            setMinDtforStart = rangecustomEnd;

        setMinDtforStart.setDate(rangecustomEnd.getDate() - 365);

        $(rangecustomStartId).datepicker('option', 'minDate', setMinDtforStart);
        $(rangecustomStartId).datepicker('option', 'maxDate', $(rangecustomEndId).datepicker('getDate'));
        $(this).blur();
      },
      endDate: 'today'
    });
  }
};

$('document').ready(function() {
  if ($('.ph-os-orderreports').length > 0) {
    ACC.orderReports.init();
    ACC.orderReports.getStatusList();
    ACC.orderReports.initCustomDatePicker();
    ACC.orderReports.reportListProcess(false);
  }
});
